import Helpers from "commons/helpers";
import Constants from "constants/index";
import CommonService from "./common.service";
import { IResponseGetPaged } from "commons/interfaces";

export interface IDetailCodename {
    group: string;
    code: string;
    name: string;
    shortName: string;
    serviceCode: string;
    organizationId: string;
    id: string;
    status: number;
    createTime: string;
    createUser: string;
    updateTime: string;
    updateUser: string;
}

class CodenameService extends CommonService {

    public getByGroup = async (data: {
        group: string;
        serviceCode: string;
        includeCommon: number;
        organizationId: string;
    }): Promise<Record<string, IDetailCodename[]>> => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({
            path: Constants.ApiPath.CODENAME.GET_BY_GROUP + `${query ? "?" : ""}${query}`
        });
        return result.data.result;
    }

    public getByCode = async (code: string): Promise<Record<string, IDetailCodename[]>> => {
        const result = await this.api.get({
            path: Constants.ApiPath.CODENAME.GET_BY_CODE + `?${code}`
        });
        return result.data.result;
    };

    public getPaged = async (data: {
        serviceCode: string;
        organizationId?: string;
        code?: string;
        name?: string;
        group?: string;
        orderby?: string;
        pageSize?: number;
        pageNumber?: number;
        includeCommon?: number;
    }): Promise<IResponseGetPaged<IDetailCodename>> => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({
            path: Constants.ApiPath.CODENAME.GET_PAGED + `${query ? "?" : ""}${query}`
        });
        return result.data.result;
    };

    public getDetail = async (id: string): Promise<IDetailCodename> => {
        const result = await this.api.get({
            path: Constants.ApiPath.CODENAME.DETAIL + `/${id}`
        });
        return result.data.result;
    };

    public delete = async (id: string) => {
        const result = await this.api.delete({
            path: Constants.ApiPath.CODENAME.DELETE + `/${id}`
        });
        return result.data.result;
    };

    public create = async (data: {
        code?: string,
        name?: string,
        group?: string,
        shortName?: string,
        serviceCode?: string,
        organizationId?: string,
    }) => {
        const result = await this.api.post({
            path: Constants.ApiPath.CODENAME.CREATE,
            data: data,
        });
        return result.data.result;
    };

    public update = async (data: {
        id?: string,
        code?: string,
        name?: string,
        group?: string,
        shortName?: string,
        updateTime?: string,
        serviceCode?: string,
        organizationId?: string,
    }) => {
        const result = await this.api.post({
            path: Constants.ApiPath.CODENAME.UPDATE,
            data: data,
        });
        return result.data.result;
    };


}

export default CodenameService;